import angular, { IHttpResponse } from "angular";
import { IReport } from "../../interfaces/IReport";
import { IReportGroup } from "../../interfaces/IReportGroup";
import { vsName as reportingServerName, ReportingServer } from '../../server'

const modalOptions: angular.ui.bootstrap.IModalSettings = {
  templateUrl: require('./modal.html')
}

export class ReportBatchDownloaderController {
  private static $inject: string[] = ['$uibModal', '$scope', '$window', reportingServerName]

  private readonly $uibModal: angular.ui.bootstrap.IModalService;
  private readonly $scope: angular.IScope;
  private readonly reportGroup: IReportGroup | undefined
  private readonly items: any[] | undefined
  private readonly reportingServer: ReportingServer
  private readonly $window: angular.IWindowService
  private modalInstance: angular.ui.bootstrap.IModalInstanceService | undefined

  private selectedReportFlags: { [reportId: string]: boolean | null } = {}
  private showSpinner: boolean = false
  private cancelDisabled: boolean = false
  private submitDisabled: boolean = false
  private errorMessage: string = ''

  private readonly itemToIdMap: ((item: any) => number) | undefined

  constructor($uibModal: angular.ui.bootstrap.IModalService, $scope: angular.IScope, $window: angular.IWindowService, reportingServer: ReportingServer) {
    this.$uibModal = $uibModal
    this.$scope = $scope
    this.reportingServer = reportingServer
    this.$window = $window
  }

  buttonClicked() {
    const reportGroup = this.reportGroup
    if (!reportGroup) {
      return
    }

    this.modalInstance = this.$uibModal.open({
      templateUrl: require('./modal.html'),
      scope: this.$scope
    })
  }

  private downloadReports() {
    const reportGroup = this.reportGroup
    if (reportGroup === undefined) {
      return
    }

    const selectedReports = this.getSelectedReports()

    this.showSpinner = this.cancelDisabled = this.submitDisabled = true

    const idMap = this.itemToIdMap ?? (item => item.Id)

    const modalInstance = this.modalInstance
    const reportNames = Object.keys(selectedReports)
    const ids = this.items?.map(idMap) ?? []

    this.reportingServer.renderReportBatch({
      reports: reportNames,
      ids,
      batchUrl: reportGroup.BatchUrl
    })
      .then((zipFile: IHttpResponse<Blob>) => {
        const blobUrl = this.$window.URL.createObjectURL(zipFile)
        const downloadLink = angular.element('<a></a>')
        downloadLink.attr('href', blobUrl)
        downloadLink.attr('download', 'reports.zip')
        downloadLink[0].click()
        modalInstance?.close(selectedReports)
      })
      .catch(error => {
        this.errorMessage = error?.message ?? 'Unknown error occurred.  Please try again'
      })
      .finally(() => {
        this.showSpinner = this.cancelDisabled = this.submitDisabled = false
      })

  }

  private getSelectedReports() {
    const reportGroup = this.reportGroup
    if (reportGroup === undefined) {
      return {}
    }

    const selectedReports = Object.entries(this.selectedReportFlags).reduce((result: { [name: string]: IReport }, next) => {
      const [key, value] = next

      const report = value ? this.reportGroup?.Reports[key] : undefined
      if (report) {
        result[key] = report
      }
      return result
    }, {})

    return selectedReports
  }
}
